import { useMemo } from "react";
import DashboardCard from "../components/DashboardCard";
import { useAuth } from "../context/AuthContext";
import { dashboardCards } from "../data/dashboardCards";
import usePageTitle from "../hooks/usePageTitle";

function DashboardPage() {
  const { hasModuleAccess, modules } = useAuth();
  usePageTitle("Dashboard | Pargro");

  const moduleDetailsByKey = useMemo(
    () => new Map(modules.map((module) => [module.key, module])),
    [modules],
  );
  const visibleCards = useMemo(
    () =>
      dashboardCards
        .filter(
          (card) =>
            card.availableWithoutModulePermission ||
            hasModuleAccess(card.moduleKey),
        )
        .map((card) => {
          const moduleDetails = moduleDetailsByKey.get(card.moduleKey);

          return {
            ...card,
            title: moduleDetails?.title || card.title,
            description: moduleDetails?.description || card.description,
            href: moduleDetails?.frontendPath || card.href,
          };
        }),
    [hasModuleAccess, moduleDetailsByKey],
  );

  return (
    <section className="min-h-[calc(100vh-74px)] bg-[#f4f7fb]">
      <section className="px-[clamp(0.75rem,2.5vw,2rem)] pb-4 pt-[clamp(1.25rem,2.5vw,1.875rem)]" aria-label="Dashboard links">
        <div className="grid grid-cols-4 gap-[clamp(0.75rem,1.6vw,1.25rem)] max-[1180px]:grid-cols-2 max-[720px]:grid-cols-1">
          {visibleCards.map((card, index) => (
            <DashboardCard card={card} key={card.title || card.href || index} />
          ))}
        </div>
        {visibleCards.length === 0 ? (
          <div className="rounded-[8px] bg-white px-5 py-6 text-center text-base text-[#4b5563] shadow-[0_3px_13px_rgba(15,23,42,0.12)]">
            No modules are assigned to your role.
          </div>
        ) : null}
      </section>
    </section>
  );
}

export default DashboardPage;
